import { createSlice } from "@reduxjs/toolkit";

const draftFilterSlice = createSlice({
    name: "contentSchedularReducer",
    initialState: {
        contentTypeLoading: false,
        contentTypeData: null,
        contentTypeError: null,

        authorEmailLoading: false,
        authorEmailData: null,
        authorEmailError: null,

        contentTitleLoading: false,
        contentTitleData: null,
        contentTitleError: null,

        entityTypeLoading: false,
        entityTypeData: null,
        entityTypeError: null,

        entityNameLoading: false,
        entityNameData: null,
        entityNameError: null,

        // draft tab (list data)
        draftListLoading:false,
        draftListData:null,
        draftListError:null,

        // draft list data for popup
        viewDrafsLoading:false,
        viewDraftsData:null,
        viewDraftsError:null,

        // queue tab (list data)
        queueDraftsLoading: false,
        queueDraftsData: null,
        queueDraftsError: null,

        // get detail for scheduling draft
        scheduleDraftsLoading: false,
        scheduleDraftsData: null,
        scheduleDraftsError: null,

        // schedule draft 
        putScheduleDraftsLoading: false,
        putScheduleDraftsData: null,
        putScheduleDraftsError: null,

        // published tab (list data)
        publishedListLoading:false,
        publishedListData:null,
        publishedListError:null,

        // publish now
        publisNowLoading:false,
        publishNowData:null,
        punlishNowError:null,

        message:null,
        
    },
    reducers: {
        getContentTypeLoading(state, action) {
            return {
                ...state,
                contentTypeLoading: true,
            };
        },
        getContentTypeSuccess(state, action) {
            return {
                ...state,
                contentTypeLoading: false,
                contentTypeData: action.payload,
            };
        },
        getContentTypeFailure(state, action) {
            return {
                ...state,
                contentTypeLoading: false,
                contentTypeError: action.payload,
            };
        },
        
        getAuthorEmailLoading(state, action) {
            return {
                ...state,
                authorEmailLoading: true,
            };
        },
        getAuthorEmailSuccess(state, action) {
            return {
                ...state,
                authorEmailLoading: false,
                authorEmailData: action.payload,
            };
        },
        getAuthorEmailFailure(state, action) {
            return {
                ...state,
                authorEmailLoading: false,
                authorEmailError: action.payload,
            };
        },

        getContentTitleLoading(state, action) {
            return {
                ...state,
                contentTitleLoading: true,
            };
        },
        getContentTitleSuccess(state, action) {
            return {
                ...state,
                contentTitleLoading: false,
                contentTitleData: action.payload,
            };
        },
        getContentTitleFailure(state, action) {
            return {
                ...state,
                contentTitleLoading: false,
                contentTitleError: action.payload,
            };
        },

        getEntityTypeLoading(state, action) {
            return {
                ...state,
                entityTypeLoading: true,
            };
        },
        getEntityTypeSuccess(state, action) {
            return {
                ...state,
                entityTypeLoading: false,
                entityTypeData: action.payload,
            };
        },
        getEntityTypeFailure(state, action) {
            return {
                ...state,
                entityTypeLoading: false,
                entityTypeError: action.payload,
            };
        },

        getEntityNameLoading(state, action) {
            return {
                ...state,
                entityNameLoading: true,
            };
        },
        getEntityNameSuccess(state, action) {
            return {
                ...state,
                entityNameLoading: false,
                entityNameData: action.payload,
            };
        },
        getEntityNameFailure(state, action) {
            return {
                ...state,
                entityNameLoading: false,
                entityNameError: action.payload,
            };
        },

        getDraftListLoading(state, action) {
            return {
                ...state,
                draftListLoading: true,
            };
        },
        getDraftListSuccess(state, action) {
            return {
                ...state,
                draftListLoading: false,
                draftListData: action.payload,
            };
        },

        getDraftListFailure(state, action) {
            return {
                ...state,
                draftListLoading: false,
                draftListError: action.payload,
                message: action.payload,
            }
        },

        getViewDraftsLoading(state, action) {
            return {
                ...state,
                viewDrafsLoading: true,
            };
        },
        getViewDraftsSuccess(state, action) {
            return {
                ...state,
                viewDrafsLoading: false,
                viewDraftsData: action.payload,
            };
        },

        getViewDraftsFailure(state, action) {
            return {
                ...state,
                viewDrafsLoading: false,
                viewDraftsError: action.payload,
                message: action.payload,
            }
        },

        getQueueDraftsLoading(state, action) {
            return {
                ...state,
                queueDraftsLoading: true,
            };
        },
        getQueueDraftsSuccess(state, action) {
            return {
                ...state,
                queueDraftsLoading: false,
                queueDraftsData: action.payload,
            };
        },

        getQueueDraftsFailure(state, action) {
            return {
                ...state,
                queueDraftsLoading: false,
                queueDraftsError: action.payload,
                message:action.payload,
            }
        },

        getScheduleDraftsLoading(state, action) {
            return {
                ...state,
                scheduleDrafsLoading: true,
            };
        },
        getScheduleDraftsSuccess(state, action) {
            return {
                ...state,
                scheduleDrafsLoading: false,
                scheduleDraftsData: action.payload,
            };
        },

        getScheduleDraftsFailure(state, action) {
            return {
                ...state,
                scheduleDrafsLoading: false,
                scheduleDraftsError: action.payload,
                message:action.payload,
            }
        },

        putScheduleDraftLoading(state, action) {
            return {
                ...state,
                putScheduleDraftsLoading: true,
            };
        },
        putScheduleDraftSuccess(state, action) {
            return {
                ...state,
                schedulDrafsLoading: false,
                putScheduleDraftsData: action.payload,
            };
        },

        putScheduleDraftFailure(state, action) {
            return {
                ...state,
                putScheduleDraftsLoading: false,
                putScheduleDraftsError: action.payload,
                message:action.payload,
            }
        },

        getPublishedListLoading(state, action) {
            return {
                ...state,
                publishedListLoading: true,
            };
        },
        getPublishedListSuccess(state, action) {
            return {
                ...state,
                publishedListLoading: false,
                publishedListData: action.payload,
            };
        },

        getPublishedListFailure(state, action) {
            return {
                ...state,
                publishedListLoading: false,
                publishedListError: action.payload,
                message:action.payload,
            }
        },
    
        getPublisNowLoading(state, action) {
            return {
                ...state,
                publisNowLoading: true,
            };
        },
        getPublisNowSuccess(state, action) {
            return {
                ...state,
                publisNowLoading: false,
                publishNowData: action.payload,
            };
        },

        getPublisNowFailure(state, action) {
            return {
                ...state,
                publisNowLoading: false,
                punlishNowError: action.payload,
                message:action.payload,
            }
        },

        clearData(state, action) {
            return {
                ...state,
                // viewDraftsData:null,
                draftListError: null,
                // scheduleDraftsData:null,
                putScheduleDraftsData:null,
                putScheduleDraftsError:null,
                punlishNowError:null,
                publishNowData:null,
                // contentTitleData:null,
                message:null,
            }
        },
    },
});
export const {
    getContentTypeLoading,
    getContentTypeSuccess,
    getContentTypeFailure,

    getAuthorEmailLoading,
    getAuthorEmailSuccess,
    getAuthorEmailFailure,

    getContentTitleLoading,
    getContentTitleSuccess,
    getContentTitleFailure,

    getEntityTypeLoading,
    getEntityTypeSuccess,
    getEntityTypeFailure,

    getEntityNameLoading,
    getEntityNameSuccess,
    getEntityNameFailure,

    getDraftListLoading,
    getDraftListSuccess,
    getDraftListFailure,

    getViewDraftsLoading,
    getViewDraftsSuccess,
    getViewDraftsFailure,

    getQueueDraftsLoading,
    getQueueDraftsSuccess,
    getQueueDraftsFailure,

    getScheduleDraftsLoading,
    getScheduleDraftsSuccess,
    getScheduleDraftsFailure,

    putScheduleDraftLoading,
    putScheduleDraftSuccess,
    putScheduleDraftFailure,

    getPublishedListLoading,
    getPublishedListSuccess,
    getPublishedListFailure,

    getPublisNowLoading,
    getPublisNowSuccess,
    getPublisNowFailure,

    clearData,

} = draftFilterSlice.actions;

  export default draftFilterSlice.reducer;